import {
  ChevronDownIcon,
  ChevronUpIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline';
import { twJoin } from 'tailwind-merge';

import { Tooltip } from '@/components/ui/custom/dataDisplay/Tooltip';
import IconButton from '@/components/ui/custom/buttons/IconButton';
import {
  FilterFormProps,
  DualArrowOrderingFilterProps,
} from '@/models/FilterConfig';
import Text from '@/components/ui/custom/dataDisplay/Text';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';

type OrderingButtonProps = {
  direction: 'asc' | 'desc';
  isActive: boolean;
  onClick: () => void;
  label: string;
};

function OrderingButton(props: OrderingButtonProps) {
  const { direction, isActive, onClick, label } = props;
  const Icon = direction === 'asc' ? ChevronUpIcon : ChevronDownIcon;

  return (
    <Tooltip text={label}>
      <IconButton
        testId={`${direction}Button`}
        onClick={onClick}
        icon={
          <Icon
            className={twJoin(
              'text-primary w-4 h-fit',
              isActive ? 'stroke-[4]' : '',
            )}
            viewBox="0 0 24 20"
          />
        }
      />
    </Tooltip>
  );
}

export default function DualArrowOrderingFilter(
  props: DualArrowOrderingFilterProps & FilterFormProps,
) {
  const { label, name, options, setValue, value } = props;

  const [ascending, descending] = options;

  return (
    <fieldset className="flex gap-1 items-center">
      <Text text={label} className="text-14 lg:text-16" />
      <div className="flex flex-col self-center font-400">
        <OrderingButton
          direction="asc"
          isActive={value === ascending.value}
          onClick={() => setValue(name, ascending.value)}
          label={ascending.label}
        />
        <OrderingButton
          direction="desc"
          isActive={value === descending.value}
          onClick={() => setValue(name, descending.value)}
          label={descending.label}
        />
      </div>
      <ConditionalRenderer condition={value !== undefined}>
        <IconButton
          icon={<XMarkIcon className="text-error w-4 h-4" />}
          onClick={() => setValue(name, undefined)}
        />
      </ConditionalRenderer>
    </fieldset>
  );
}
